export default {
  "content": "<path d=\"M5.183 14.509c.482.041.9.228 1.21.542.355.36.545.867.545 1.441 0 1.105-.777 1.833-1.454 2.412l-.178.154H7V20.5H3v-1.222l1.334-1.184c.34-.3.638-.564.854-.828.213-.263.313-.49.313-.715 0-.21-.06-.365-.146-.464a.473.473 0 00-.272-.154.666.666 0 00-.251 0c-.266.057-.442.307-.442.64 0 .134.02.268.064.397l.139.413H3.17l-.067-.207A1.95 1.95 0 013 16.522c0-1.117.8-1.917 1.775-2.012.065-.007.131-.01.198-.01l.21.009zM21 19H9v-2h12v2zM21 13H9v-2h12v2zM5.815 7.584H7V9H3V7.584h1.342v-2.29H3.028V4.008l.794-.069h.002c.306-.024.456-.084.54-.159.072-.066.142-.192.164-.493L4.55 3h1.265v4.584zM21 7H9V5h12v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};